import { useState } from "react";

import Card from "~/components/Card";
import DetailsListDivider from "~/components/DetailsList/components/DetailsListDivider";
import DetailsListItem from "~/components/DetailsList/components/DetailsListItem";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import { useAuth } from "~/contexts/AuthContext";
import type { Project } from "~/modules/project/api/project/projectTypes.ts";
import UpdateProjectBillingInformationSidebar
	from "~/modules/project/components/ProjectDetailsView/components/ProjectOverviewContent/components/ProjectBillingInformationSection/components/UpdateProjectBillingInformationSidebar";
import { PermissionNames } from "~/types/entityNames.ts";
import { nl2br } from "~/utils/stringUtils.tsx";

type Props = { projectData: Project };

const ProjectBillingInformationSection = ({ projectData }: Props) => {
	const {hasAnyPermission} = useAuth();
	const userCanManageInvoices = hasAnyPermission([PermissionNames.CanManageInvoices]);
	const [showUpdateProjectBillingInformationSidebar, setShowUpdateProjectBillingInformationSidebar] = useState<boolean>(false);
	return <><Card title="Abrechnung"
				   onHeaderButtonClick={userCanManageInvoices ? () => setShowUpdateProjectBillingInformationSidebar(true):undefined}
				   headerButtonText={userCanManageInvoices ? "Bearbeiten":undefined}
	>
		<div className="grid grid-cols-[auto_1fr] gap-4">
			<DetailsListItem label="Sammelrechnung für all Phasen">
				{projectData.billOrdersSeparately ? "Nein" : "Ja"}
			</DetailsListItem>
			<DetailsListDivider />
			<DetailsListItem label="Hinweise zur Abrechnung">
				{projectData.billingInstructions ? nl2br(projectData.billingInstructions) : EMPTY_VALUE_PLACEHOLDER}
			</DetailsListItem>
		</div>
	</Card>
		{userCanManageInvoices && <UpdateProjectBillingInformationSidebar isOpen={showUpdateProjectBillingInformationSidebar}
												onClose={() => setShowUpdateProjectBillingInformationSidebar(false)}
												projectData={projectData} />}
	</>;
};

export default ProjectBillingInformationSection;